module.exports = __webpack_public_path__ + "static/media/value-absolute.bd800446.svg";